// Default values
export const DEFAULT_TIMEOUT_HOURS = 3;

// Message display durations (in milliseconds)
export const SUCCESS_MESSAGE_DURATION_MS = 3000;
export const ERROR_MESSAGE_DURATION_MS = 5000;

// Error messages
export const ERROR_MESSAGES = {
  LOADING_OPTIONS: 'Error al cargar las opciones de configuración',
  MUST_SELECT_OPTION: 'Debes tener una opción seleccionada',
  UPDATE_ERROR: 'Error al actualizar la configuración. Intente nuevamente',
} as const;

// Success messages
export const SUCCESS_MESSAGES = {
  CONFIGURATION_UPDATED: 'Configuración actualizada correctamente',
} as const;
